import { startOfDay, subDays } from 'date-fns';
import React, { useMemo } from 'react';

import { useCatalystInsightsList } from '~/react-query-hooks/insights/useCatalystInsights';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { useFlags } from '~/stores/use-flags/useFlags';
import { CatalystInsightPill } from '~/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';

import { ThemeLogoIcon } from '../theme-logo-icon/ThemeLogoIcon';
import * as S from './ThemeHeader.styles';

interface ThemeHeaderProps {
  themeId: string;
  themeName: string;
  logo_url?: string;
  isCondensed?: boolean;
}

export const ThemeHeader = ({
  themeId,
  themeName,
  logo_url,
  isCondensed = false,
}: ThemeHeaderProps) => {
  const isCatalystsThemeInsightsEnabled = useFlags(state =>
    state.getFeatureFlagState('catalysts_theme_insights')
  );

  const fromDate = useMemo(() => startOfDay(subDays(new Date(), 3)), []);
  const { data: catalystInsightsData } = useCatalystInsightsList(
    {
      themes: [themeId],
      categories: ['market_wide'],
      from: fromDate.toISOString(),
      page: 1,
      page_size: 1,
    },
    isCatalystsThemeInsightsEnabled
  );

  return (
    <>
      <S.FlexRowWrapper>
        <S.LogoAndTitleWrapper $isCondensed={isCondensed}>
          <ThemeLogoIcon
            logo_url={logo_url}
            name={themeName}
            key={themeName}
            isCondensed={isCondensed}
          />
          <S.TitleText $isCondensed={isCondensed}>{themeName}</S.TitleText>
        </S.LogoAndTitleWrapper>
        {!!catalystInsightsData?.length && (
          <CatalystInsightPill
            insightId={catalystInsightsData[0].id}
            themeId={themeId}
            type="theme"
            isClickable
            source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
          />
        )}
      </S.FlexRowWrapper>
    </>
  );
};
